module.exports = __webpack_public_path__ + "static/media/icon_thumbs_up.6d8ad7f0.svg";